import { GpuMetricKey } from './_types';

export const gpuMetricToColor: Record<GpuMetricKey, string> = {
  gpuPercent: 'aqua.600',
  recGpu: 'grey.900',
  memoryUsedGB: 'yellow.900',
  recMemoryUsedGB: 'grey.900',
  deviceCount: 'grey.300',
  recDeviceCount: 'grey.900',
};

export const gpuMetricToTitle: Record<GpuMetricKey, string> = {
  gpuPercent: 'Avg. GPU utilization',
  recGpu: 'Avg. recomm. GPU utilization',
  memoryUsedGB: 'Avg. GPU memory',
  recMemoryUsedGB: 'Avg. GPU memory recomm.',
  deviceCount: 'GPU count',
  recDeviceCount: 'Recommended GPU count',
};

export const gpuMetricToTooltipTitle: Record<GpuMetricKey, string> = {
  gpuPercent: 'Avg. GPU',
  recGpu: 'Recommended',
  memoryUsedGB: 'Avg. GPU memory',
  recMemoryUsedGB: 'Recommended',
  deviceCount: 'GPU count',
  recDeviceCount: 'Recommended',
};
